import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';
import { translate } from 'react-i18next';

const AdditionalDiscussionCheckbox = ({ checked, onChange, t }) => (
  <Checkbox
    className="text-center"
    checked={checked}
    onChange={onChange}
  >
    {t('additional_discussion_checkbox_label')}
  </Checkbox>
);

AdditionalDiscussionCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

AdditionalDiscussionCheckbox.defaultProps = {
  checked: false
};

export default translate(['booking'], { wait: true })(AdditionalDiscussionCheckbox);



// WEBPACK FOOTER //
// ./src/components/AdditionalDiscussionCheckbox/index.jsx